import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service worker dédié au cache des photos (produits, recettes, sites, guide).
// Les URLs d'images sont versionnées (?v=...) : tout changement de photo est
// donc immédiatement visible. Les anciens SW (mode offline retiré) sont purgés.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => {
      const url = r.active?.scriptURL || r.installing?.scriptURL || r.waiting?.scriptURL || '';
      if (!url.includes('sw-images.js')) r.unregister();
    }))
    .catch(() => {});
  if (window.caches) {
    caches.keys()
      .then(keys => keys.filter(k => !k.startsWith('sokuzai-images-')).forEach(k => caches.delete(k)))
      .catch(() => {});
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-images.js').catch(() => {});
  });
}
